import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import useSession from 'core/hooks/use-session';
import { oAuthStorage } from 'core/components/auth';
import { useViewAs } from 'core/components/view-as';

export const ProtectedRoute = (props) => {
  const session = useSession();
  const viewAs = useViewAs();
  const { permission } = props;

  if (session.isLoggedIn && permission) {
    return <Route {...props} />;
  }

  // A page the View as agent can't open: leave it without the reload, which would end the lens.
  if (viewAs?.active) {
    return <Redirect to="/" />;
  }

  // Save current URL so we can redirect to it after successful login to enable deep linking.
  // Only save the deep link if the user is unauthenticated; if they're logged in but lack
  // permission (wrong role, feature flag off, etc.), we don't want to redirect them back to a
  // page they can't access, which would create an infinite loop with HomeRedirect.
  if (!session.isLoggedIn) {
    oAuthStorage.setDeepLink(window.location.href);
  }
  window.location.href = '/';
  return <></>;
};

ProtectedRoute.propTypes = {
  permission: PropTypes.bool,
  avoidRedirect: PropTypes.bool
};

ProtectedRoute.defaultProps = {
  permission: false,
  avoidRedirect: false
};
